import * as React from 'react';
import { AnchorLink } from './link-components';

type Props = {
  variant?: 'primary' | 'secondary' | 'white';
  fontSize?: string;
  href: string;
  onClick?: (e: any) => void;
  children: any;
};
export default function Link({
  variant = 'primary',
  fontSize,
  href,
  onClick,
  children,
}: Props) {
  return (
    <AnchorLink
      variant={variant}
      fontSize={fontSize}
      to={href}
      onClick={onClick}>
      {children}
    </AnchorLink>
  );
}
